import React from "react";
import PropTypes from "prop-types";

function LandingPage({ children }) {
  return <div>{children}</div>;
}

LandingPage.propTypes = {
  children: PropTypes.node.isRequired, // Ensures children are React nodes (JSX, strings, elements)
};

export default LandingPage;
